/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import TimeFieldItemEdit from "./edit-item";

const TimeFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <TimeFieldItemEdit />
        </FieldListEditWrapper>
    );
};
TimeFieldEdit.displayName = "TimeFieldEdit";
export { TimeFieldEdit };
